import Layout from '@/libs/components/Layout'
import { getUrlParam } from '@/libs/functions/getValue'
import goTo from '@/libs/functions/goTo'
import { bossOrderToPay, CarOrderPayDetail, getCarOrder } from '@/services'
import styles from './index.scss'
import { Toast } from 'antd-mobile'
import { useEffect, useState } from 'react'

export default function LimousineOrderPay() {
  const orderCode = getUrlParam('orderCode') || ''
  const [detail, setDetail] = useState<CarOrderPayDetail | null>(null)
  const [selectedPayType, setSelectedPayType] = useState('')
  const [loading, setLoading] = useState(true)
  const [paying, setPaying] = useState(false)

  useEffect(() => {
    getOrderDetail()
  }, [orderCode])

  const getOrderDetail = async () => {
    if (!orderCode) {
      setDetail(null)
      setSelectedPayType('')
      setLoading(false)
      return
    }

    setLoading(true)
    try {
      const res = await getCarOrder({
        lg: 'zh-cn',
        orderCode,
        sensitive: false,
      })
      setDetail(res)
      setSelectedPayType(res?.payWayList?.[0]?.type || '')
    } catch (error) {
      setDetail(null)
      setSelectedPayType('')
    } finally {
      setLoading(false)
    }
  }

  const getBackUrl = () => {
    return `${window.location.origin}/#/customer/smsPay/LS/result`
  }

  const handleConfirmPay = async () => {
    if (paying) return
    if (!detail || !orderCode) return

    const payWay = (detail.payWayList || []).find(
      (item) => item.type === selectedPayType,
    )

    if (!payWay?.type) {
      Toast.show({
        content: '请选择支付方式',
      })
      return
    }

    setPaying(true)
    try {
      const res = await bossOrderToPay({
        orderNo: orderCode,
        payType: payWay.type,
        url: getBackUrl(),
        title: '龙腾出行礼宾车支付',
      })
      const { url } = res || {}
      if (!url) return

      if (payWay.type === 'alipay') {
        goTo(url)
      } else {
        window.location.replace(url)
      }
    } finally {
      setPaying(false)
    }
  }

  const orderInfoRows = [
    { label: '订单号', value: detail?.orderCode },
    { label: '乘车人', value: detail?.person },
    { label: '手机号', value: detail?.personPhone },
    { label: '服务类型', value: detail?.serviceTypeNewStr },
    { label: '车型', value: detail?.carLevel },
    { label: '航班号', value: detail?.flightName },
    { label: '航程', value: detail?.flightFT },
    { label: '起飞时间', value: detail?.departureTime },
    { label: '落地时间', value: detail?.fallTime },
    { label: '服务时间', value: detail?.serviceTime },
  ]

  return (
    <Layout title="龙腾出行礼宾车支付">
      <div className={styles.page}>
        {!loading && detail && (
          <>
            <div className={styles.pricePanel}>
              <div className={styles.priceLabel}>支付金额</div>
              <div className={styles.price}>¥{detail.cusPrice}</div>
            </div>

            <div className={styles.section}>
              <div className={styles.sectionTitle}>订单信息</div>
              {orderInfoRows.map((item) => (
                <div className={styles.infoRow} key={item.label}>
                  <span className={styles.infoLabel}>{item.label}</span>
                  <span className={styles.infoValue}>{item.value || '-'}</span>
                </div>
              ))}
            </div>

            <div className={styles.section}>
              <div className={styles.sectionTitle}>支付方式</div>
              {(detail.payWayList || []).map((item) => (
                <div
                  className={styles.payWayItem}
                  key={item.type}
                  onClick={() => setSelectedPayType(item.type)}
                >
                  <img className={styles.payLogo} src={item.logo} />
                  <span className={styles.payName}>{item.value}</span>
                  <span
                    className={`${styles.radio} ${
                      selectedPayType === item.type ? styles.radioActive : ''
                    }`}
                  />
                </div>
              ))}
            </div>
          </>
        )}

        {!loading && !detail && (
          <div className={styles.empty}>暂无订单支付信息</div>
        )}

        <div className={styles.bottomBtn}>
          <div className={styles.button} onClick={handleConfirmPay}>
            确认支付
          </div>
        </div>
      </div>
    </Layout>
  )
}
